import React from 'react';
// import { OrdersTable2 } from '../components/orders/OrdersTable2';
import { OrdersTable3 } from '../components/orders/OrdersTable3';

export const Orders = () => {
	return <OrdersTable3 />;
};
